if (!customElements.get('section-videos')) {
  customElements.define(
    'section-videos',
    class SectionVideos extends HTMLElement {
      constructor() {
        super();

        this.initSlider();
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', `${index}`);
      }

      initSlider() {
        this.sliderOptions = {
          slidesPerView: 3,
          spaceBetween: 40,
          grabCursor: true,
          allowTouchMove: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1.3075,
              spaceBetween: 15,
              centeredSlides: true,
            },
            577: {
              slidesPerView: 2.2,
              spaceBetween: 25,
              centeredSlides: false,
            },
            990: {
              slidesPerView: 3,
              spaceBetween: 40,
              centeredSlides: false,
            },
          }
        };
        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }
    }
  );
}
